import { GenericItemListTranslations } from './generic-item-list-translations.interface';

export const GERMAN_GENERIC_ITEM_LIST_TRANSLATIONS: GenericItemListTranslations = {
  labels: {
    groupLabel: 'Elementliste',
    emptyList: 'Keine Elemente vorhanden.',
    itemLabel: 'Element',
    itemEntry: 'Element {index} von {total}',
  },
  buttons: {
    appendItem: 'Element hinzufügen',
    appendItemLabel: 'Element hinzufügen',
    removeItem: 'Element {index} entfernen',
  },
};
